import React from "react";
import { Button, Icon } from "@blueprintjs/core";
import styled from "styled-components";

const StyledButton = styled(Button)`
  position: absolute;
  right: 64px;
  top: 3px;
  background: none;
  min-height: 0;
  height: 24px;
  width: 32px;
  font-size: var(--global-font-size-xs);
  padding: 0;
  background: #2b2d6c !important;
  border-radius: 4px;
  border: 1px solid #0f1446;
  :hover {
    background: #7a6bcb !important;
  }
  ${({ active }) =>
    active &&
    `
    background: #7a6bcb !important;
  `}
`;

const NotificationDot = styled(Icon)`
  position: absolute;
  right: 64px;
  top: 3px;
  color: var(--global-green);
`;

interface Props {
  active: boolean;
  onClick: () => void;
  showSuccess: boolean;
}

const OutputButton: React.FC<Props> = ({ active, onClick, showSuccess }) => {
  return (
    <>
      <StyledButton active={active} onClick={onClick}>
        <Icon icon={"widget-button"} color={"var(--global-light-gray)"} />
      </StyledButton>
      {showSuccess && <NotificationDot icon={"full-circle"} size={10} />}
    </>
  );
};

export default OutputButton;
